// refreshNotifications(): a module may ask the bell to re-count now, after an action it
// knows created a notice for the current user. Optional: the bell polls anyway. Exported
// to modules through @platform/shell (module-api.js).
const listeners = new Set();

export function refreshNotifications() {
  for (const fn of [...listeners]) {
    try { fn(); } catch { /* a listener's failure never reaches the module that asked */ }
  }
}

/** The bell subscribes; returns the unsubscribe. */
export function onNotificationsRefresh(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
